import React, { Fragment } from 'react';
import { Section } from './ProductPage';
import { styled } from 'linaria/react';
import { theme } from '../Theming/Theming';
import t from '@jetshop/intl';
import ImageSlider from './ImageSlider/ImageSlider';
import { Header, PriceWrapper, ProductHeading } from './ProductDetails';
import { Favourite } from '../ProductList/Favourite';
import { Designer } from './Designer';
import { ProductInfoMarginBottom } from './StyledComponents';
import { GridPrice as Price } from '../Price';
import { BuyButton, buyHeightStyle } from './AddToCart/AddToCartWrapper';

const LoadingLine = styled.div`
  max-width: 100%;
  width: 100%;
  background: #f5f5f5;
  ${ProductInfoMarginBottom}
`;

const MockImage = styled('div')`
  width: 100%;
  padding-top: 75%;
  background: #f5f5f5;
  ${theme.below.md} {
    order: 1;
    width: 100%;
    margin-bottom: 1rem;
  }
  ${theme.below.sm} {
    width: 100vw;
    padding-top: 100%;
  }
`;

const BuyArea = styled.div`
  display: flex;
  margin-top: 1rem;
  .input-selector {
    ${buyHeightStyle}
  }
`;

export default function ProductPageLoadingState({ product, designerCategory }) {
  return (
    <Fragment>
      <Section className="product-images-wrapper">
        {product ? <ImageSlider product={product} /> : <MockImage />}
      </Section>
      <Section className="product-info-wrapper">
        <Header>
          <LoadingLine
            style={{ marginBottom: '10px', height: '20px', width: '300px' }}
          />
          <ProductHeading data-testid="product-title">
            {product ? (
              product.name
            ) : (
              <LoadingLine
                style={{ marginBottom: '10px', height: '40px', width: '400px' }}
              />
            )}
            {product && <Favourite product={product} />}
          </ProductHeading>
          {designerCategory ? (
            <Designer category={designerCategory} />
          ) : (
            <LoadingLine
              style={{ marginBottom: '10px', height: '20px', width: '100px' }}
            />
          )}
        </Header>
        <LoadingLine style={{ height: '15px', width: '800px' }} />
        <LoadingLine style={{ height: '15px', width: '300px' }} />
        <LoadingLine style={{ height: '50px', margin: '2rem 0 1rem' }} />
        <PriceWrapper>
          {product ? (
            <Price
              price={product.price}
              previousPrice={product.previousPrice}
            />
          ) : (
            <LoadingLine style={{ height: '50px', margin: '2rem 0 1rem' }} />
          )}
        </PriceWrapper>
        <BuyArea>
          <LoadingLine className="input-selector" style={{ width: '90px' }} />
          <BuyButton>{t('Add to cart')}</BuyButton>
        </BuyArea>
      </Section>
    </Fragment>
  );
}
